import React from 'react';
// import Row from './Row';
import Column from './Column';

class Table extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="Table">
        <div className="Table-heading">
          {this.props.columns.map((item, index) => {
            return <Column key={index}>{item}</Column>;
          })}
        </div>
        {this.props.children}
      </div>
    );
  }
}

Table.propTypes = {
  children: React.PropTypes.node,
  columns: React.PropTypes.array
};

Table.defaultProps = {
  children: null
};

export default Table;



// WEBPACK FOOTER //
// ./src/js/components/table/Table.js